export const buildDocTypeAlias = (docTypeMap = {}) => {
    const alias = { ...docTypeMap };
    Object.values(docTypeMap).forEach((row) => {
        if (!row) return;
        if (row._id && !alias[row._id]) alias[row._id] = row;
        if (row.name && !alias[row.name]) alias[row.name] = row;
    });
    return alias;
};

export const resolveDocTypeRow = (alias, documentType) => {
    if (!alias || documentType === undefined || documentType === null) return null;
    return alias[documentType] || alias[String(documentType).trim()] || null;
};

export default buildDocTypeAlias;

